import { UiUtils } from "./ui"
import { HouseKeeperApi } from "../api/api"
import { Tablet } from "../api/model"
import { inspect } from "util"
export class HouseKeeperHelper {
    constructor(
        private houseKeeperapi: HouseKeeperApi
    ) {

    }

    /**
     * @param code 欲檢查的磁扣代碼
     * @returns 檢查未通過會跳出 Alert, 並返回 Null
     */
    async checkCarrier(code: string): Promise<Tablet> {
        if(code.length == 0){
            return Promise.resolve(null)
        }
        const result = await this.houseKeeperapi.checkCarrier(code)
        console.log("Code result:%s", inspect(result))
        //TODO - res_v2.js _checkInputCarrier
        switch (result.status) {
            case 'true':
                if (result.total == 0) {
                    UiUtils.alert('此感應卡尚未開通！')
                    break
                }
                const tablets: Array<Tablet> = result.tablets.map(it => {
                    return { id: it.tablet_id, commId: '', note: it.tablet_note }
                })
                const selectedTablet = result.total > 1 ? await this.selectTablet(false, tablets) : tablets[0]
                console.log("Tablet:%s", inspect(selectedTablet))
                return selectedTablet
            case 'failed':
                UiUtils.alert('您尚無此權限，請洽管理者！')
                break
            case 'false':
                UiUtils.alert("執行錯誤，請洽技術中心！")
                break
        }
        return null
    }

    /**
     * @param code 欲檢查的APP code
     * @returns 檢查未通過會跳出 Alert, 並返回 Null
     */
    async checkAppCode(code: string): Promise<Tablet> {
        if(code.length == 0){
            return Promise.resolve(null)
        }
        const result = await this.houseKeeperapi.checkAppCode(code)
        console.log("Code result:%s", inspect(result))
        //TODO - res_v2.js _checkInputScan
        switch (result.status) {
            case 'true':
                if (result.tablet == '') {
                    UiUtils.alert("此裝置尚未開通！")
                    break
                }
                const tabletNames = result.tablet.split('｜')
                const tabletIds = result.tablet_id.split('-')
                let tablets: Array<Tablet> = []
                for (let i = 0; i < tabletIds.length; i++) {
                    tablets.push({ id: tabletIds[i], note: tabletNames[i], commId: '' })
                }
                const selectedTablet = tablets.length > 1 ? await this.selectTablet(true, tablets) : tablets[0]
                console.log("Tablet:%s", inspect(selectedTablet))
                return selectedTablet
            case 'failed':
                UiUtils.alert('您尚無此權限，請洽管理者！')
                break
            case 'validFailed':
                UiUtils.alert('條碼驗證錯誤，請洽技術中心！')
                break
            case 'false':
                UiUtils.alert("執行錯誤，請洽技術中心！")
                break
        }
        return null
    }

    private async selectTablet(isAppCode: boolean, tablets: Array<Tablet>): Promise<Tablet> {
        const options = tablets.map(it => {
            return { text: it.note, value: it.id }
        })
        options.unshift({ text: '請選擇', value: '' })
        const prefix = isAppCode ? '此裝置綁訂多戶' : '此感應卡綁訂多戶'
        const selectedTabletOpt = await UiUtils.prompt({
            callback: null,
            title: `${prefix}，請選擇其一戶別：`,
            inputType: 'select',
            inputOptions: options
        })
        return selectedTabletOpt == '' ? null : tablets.find(it => it.id == selectedTabletOpt)
    }
}